// extracted by mini-css-extract-plugin
export var gif = "_gg-0";